import EmailForm from "../../component/EmailForm/EmailForm";
import Header from "../../component/Header/Header";
import './FaqPage.css'

function FaqPage() {

  return (
    <div className='cgu-container'>
      <Header />
      <h1 className='text-center'>FAQ</h1>
      <div>
        <p>Bienvenue sur la page de support de Spoteet. Vous trouverez ici les réponses aux questions les plus fréquentes concernant notre application et notre site.</p>

        <h2>Qu’est-ce que Spoteet ?</h2>

        <p>Spoteet est une plateforme qui permet de découvrir, partager et promouvoir des performances artistiques et culturelles. Elle est disponible sur mobile et en ligne à l’adresse <a href="https://spoteet.com">spoteet.com</a>.</p>

        <h2>L’application ne fonctionne pas correctement, que faire ?</h2>

        <p>Assurez-vous que votre application est à jour via l’App Store ou Google Play. Si le problème persiste :</p>
        <p>- Redémarrez l’application</p>
        <p>- Vérifiez votre connexion internet</p>
        <p>- Contactez notre support via <a href="mailto:support@spoteet.com">support@spoteet.com</a></p>

        <h2>Je ne reçois pas les notifications, pourquoi ?</h2>

        <p>Vérifiez dans les réglages de votre téléphone que les notifications sont autorisées pour Spoteet. Ensuite, assurez-vous que vous êtes bien connecté à votre compte dans l’application.</p>

        <h2 id="delete-account">Comment puis-je supprimer mon compte Spoteet ?</h2>

        <p>Vous pouvez demander la suppression de votre compte Spoteet et de toutes les données associées en envoyant un e-mail à <a href="mailto:support@spoteet.com">support@spoteet.com</a> ou depuis le formulaire ci-dessous.</p> 
        <p>Veuillez indiquer votre nom d’utilisateur et préciser que vous souhaitez supprimer définitivement votre compte.</p><br/>

        <p><b>Quelles données seront supprimées ?</b></p>
        <ul>
          <li>Votre profil Spoteet</li>
          <li>Vos publications, commentaires, likes</li>
          <li>Votre token de notification et ID utilisateur</li>
          <li>Toute donnée de géolocalisation ou d’utilisation liée à votre compte</li>
        </ul>

        <p><b>Quelles données sont conservées ?</b></p><br/>
        <p>Certaines données peuvent être temporairement conservées à des fins légales ou de sécurité, comme le stipule notre politique de confidentialité. Ces données seront supprimées automatiquement après un délai de 90 jours maximum.</p>

        <h2>Comment contacter l’équipe Spoteet ?</h2>

        <p>Pour toute question, suggestion ou assistance personnalisée, écrivez-nous à <a href="mailto:support@spoteet.com">support@spoteet.com</a> ou via le formulaire ci-dessous :</p>
        <EmailForm />
        <br/><br/>
        <p><strong>Dernière mise à jour : 6 mai 2025</strong></p>

      </div>
    </div>
  );
}

export default FaqPage;
